<template>
  <Modal v-model="batchReconciliationModal" :title="batchReconciliationTitle" :transfer="false" :mask-closable="false"
    width="600" @on-visible-change="batchReconciliationChange">
    <p class="mb15" v-if="batchReconciliationType === 'all'">{{ $t('key1000610') }}<span class="themeColor">{{ selectTableData.length }}</span>{{ $t('key1004650') }}</p>
    <div class="flex align-items-center mb24">
      <span>{{ $t('key1004651') }}</span>
      <RadioGroup v-model="payStatus">
        <Radio :label="4" class="mr40">{{ $t('key1004627') }}</Radio>
        <Radio :label="3">{{ $t('key1004628') }}</Radio>
      </RadioGroup>
    </div>
    <div class="flex mb24" v-if="payStatus === 3">
      <span>{{ $t('key1004652') }}</span>
      <Input type="textarea" :showWordLimit="true" :maxlength="200" style="width: 480px;" :placeholder="$t('key1004649')"
        :autosize="{ minRows: 5, maxRows: 8}" v-model.trim="returnReason">
      </Input>
    </div>
    <p>{{ $t('key1000615') }}<br/>{{ platformTips }}</p>
    <template #footer>
      <Button @click="batchReconciliationModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="batchReconciliationBtn" :disabled="payStatus === 3 && !returnReason">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'batchReconciliationModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      batchReconciliationType: null,
      batchReconciliationModal: false,
      batchReconciliationTitle: '',
      selectTableData: [],
      payStatus: 4,
      returnReason: ''
    };
  },
  computed: {
    platformTips() {
      return this.payStatus === 3 ?
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004646') :
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004647');
    }
  },
  methods: {
    // 初始化数据
    initBatchReconciliationData(type, data) {
      let obj = {
        single: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004648'),
        all: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004636')
      };
      this.batchReconciliationTitle = obj[type];
      this.batchReconciliationType = type;
      this.selectTableData = data;
      this.batchReconciliationModal = true;
    },
    // 确定
    batchReconciliationBtn() {
      let query = {
        payStatus: this.payStatus,
        returnReason: this.returnReason,
        ymsPackagePayIds: this.selectTableData.map((item) => item.ymsPackagePayId)
      };
      this.axios.post(api.post_ymsPackagePay_confirmPayVoucher, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          this.batchReconciliationModal = false;
          this.$emit('updateData', true);
        }
      });
    },
    // 监听弹窗
    batchReconciliationChange(value) {
      if (!value) {
        this.selectTableData = [];
        this.payStatus = 4;
        this.returnReason = '';
      }
    }
  }
};
</script>

<style lang="less">

</style>
